import { FullParameterData } from "@/types/crm/configuration/parameter";

export const transformParametersToObjectWithNames = (parameters?: FullParameterData[]) => {
    if (!parameters) return {};
    const res = Object.fromEntries(parameters?.map(p => {
        const value = p.value;
        return [p.name, value]
    }) ?? [])
    return res
}